import {animate, state, style, transition, trigger} from "@angular/animations";
import {TBaseAnimationPayload} from "../types";
import {DEFAULT_ANIMATION_PAYLOAD} from "./default-animation-config";


export const DROPDOWN_ANIMATION = trigger('dropdown', [
    state('open', style({
      transform: 'translateY(0%)',
      display: 'block',
      opacity: 1
    })),
    state('close', style({
      transform: 'translateY(20%)',
      display: 'none',
      opacity: 0
    })),
    transition('open => close', [
      animate('0.2s ease')
    ]),
    transition('close => open', [
      animate('0.2s ease')
    ])
  ]);

export const DROPDOWN_ANIMATION_E_TO_TOP_L_TO_BOTTOM
  = ({duration, timingFunction}: TBaseAnimationPayload = DEFAULT_ANIMATION_PAYLOAD) => trigger('dropdownETTLTB', [
  transition(':enter', [
    style({transform: 'translateY(-1rem)', opacity: 0}),
    animate(`${duration}s ${timingFunction}`, style({transform: 'translateY(0)', opacity: 1}))
  ]),
  transition(':leave', [
    animate(`${duration}s ${timingFunction}`, style({transform: 'translateY(1rem)', opacity: 0}))
  ])
])
